module.exports = __webpack_public_path__ + "aafc352c3e9cf4bab2a066e0ce343a36.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business/Kovo.svg
// module id = ./assets/images/support-business/Kovo.svg
// module chunks = 0